<template>
  <section class="contact">
    <heading :ahead="ahead" :behind="behind" />
    <div class="cover">
      <div class="left">
        <div class="avatar">
          <img src="@/assets/images/contact.svg" alt="Avatar" />
        </div>
      </div>
      <div class="right">
        <ul class="info">
          <li class="item">
            <vs-button icon :href="'mailto:' + email">
              <i class="bx bx-envelope"></i>
            </vs-button>
            <div class="text">
              {{ email }}
            </div>
          </li>
          <li class="item">
            <vs-button icon :href="linkedinUrl">
              <i class="bx bxl-linkedin"></i>
            </vs-button>
            <div class="text">
              {{ linkedin }}
            </div>
          </li>
        </ul>
        <div class="form">
          <div class="field">
            <vs-input
              class="field-item"
              type="text"
              v-model="subject"
              label="Subject"
              placeholder="Email Subject"
            />
          </div>
          <div class="field">
            <vs-input
              class="field-item"
              type="text"
              v-model="body"
              label="Message"
              placeholder="Email Body"
            />
          </div>
          <vs-button
            primary
            flat
            :href="emailData"
            @click="
              subject = '';
              body = '';
            "
          >
            Send Email
          </vs-button>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Heading from "../components/Heading.vue";

export default {
  name: "Contact",
  components: {
    Heading
  },
  data() {
    return {
      ahead: "Let's",
      behind: "Talk",

      email: "shahrozsaleem17@gmail.com",
      linkedin: "linkedin.com/in/shahroz-saleem",
      linkedinUrl: "http://linkedin.com/in/shahroz-saleem",

      subject: "",
      body: ""
    };
  },
  computed: {
    emailData() {
      let str =
        "mailto:" +
        this.email +
        "?subject=" +
        this.subject +
        "&body=" +
        this.body;
      return str;
    }
  }
};
</script>

<style scoped>
.contact {
  width: 100%;
  padding: 1em;
}

.contact::before {
  position: absolute;
  content: "";
  background: #f7f7f7;
  width: 50vw;
  height: 25vh;
  z-index: -10;
  right: 0px;
  transform: translateY(90%);
}

.cover {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 0px 2em;
}

.left {
  width: 50%;
  width: 500px;
  height: 100%;
  margin-right: 1em;
}

.avatar {
  width: 100%;
  height: 100%;
}

.avatar img {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  object-fit: cover;
}

.right {
  width: 50%;
  left: 50%;
  width: 500px;
  margin-left: 1em;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.info {
  list-style-type: none;
  padding: 1em;
  margin: 1em;
  max-width: 450px;
}

.item {
  margin: 1em;
  display: flex;
  flex-direction: row;
  align-items: center;
}

.text {
  letter-spacing: 2px;
}

.form {
  width: 100%;
  padding: 2em;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.field {
  margin: 1em;
  width: 400px;
}

.field-item {
  height: 40px;
  width: 100%;
}
</style>

<style scoped>
@media screen and (max-width: 900px) {
  .left {
    display: none;
  }

  .right {
    left: 0%;
    width: 100%;
  }
}
</style>

<style>
.field-item input {
  width: 100%;
}
</style>
